import { Component, OnDestroy } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeWhile } from 'rxjs';

import { IUser, UsersService } from '@app/core/users';
import { YesNoDialogComponent } from '@app/shared';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css'],
})
export class UserListComponent implements OnDestroy {
  public records$: Subject<IUser[]>;
  public selectedRecords: IUser[] = [];

  public totalRecords: number;
  public limit: number = 10;

  /** Buscador por nombre de usuario (se envía al backend como filtro userName) */
  public searchUserName = '';

  /** Último evento lazy para re-disparar búsqueda desde el toolbar */
  private lastLazyEvent: any = null;

  private destroyed: boolean;

  constructor(
    private service: UsersService,
    private dialogService: DialogService,
    private router: Router
  ) {
    this.records$ = new Subject();
  }

  loadUsersLazy(event: any): void {
    const first = event.first;
    const rows = event.rows;
    const sortField = event.sortField;
    const sortOrder = event.sortOrder;
    const filters = event.filters ? { ...event.filters } : {};
    if (this.searchUserName?.trim()) {
      filters.userName = [{ value: this.searchUserName.trim(), matchMode: 'contains' }];
    } else {
      delete filters.userName;
    }
    this.lastLazyEvent = { ...event, first, rows, sortField, sortOrder, filters };
    this.service
      .getList(
        rows,
        first,
        sortField,
        sortOrder > 0 ? 'asc' : 'desc',
        filters
      )
      .subscribe((response) => {
        this.records$.next(response.rows);
        this.totalRecords = response.count;
      });
  }

  /** Aplica el filtro de nombre de usuario y recarga (búsqueda en backend). Debounce 300ms. */
  private searchDebounceTimer: ReturnType<typeof setTimeout> | null = null;

  /** Aplica el filtro de nombre de usuario y recarga (búsqueda en backend) */
  onSearchUsername(): void {
    if (this.searchDebounceTimer != null) {
      clearTimeout(this.searchDebounceTimer);
    }
    this.searchDebounceTimer = setTimeout(() => {
      this.searchDebounceTimer = null;
      const event = this.lastLazyEvent || {
        first: 0,
        rows: this.limit,
        sortField: 'createdAt',
        sortOrder: -1,
        filters: {},
      };
      this.loadUsersLazy({ ...event, first: 0, filters: event.filters ? { ...event.filters } : {} });
    }, 300);
  }

  /** Limpia el buscador y recarga la lista completa */
  clearSearch(): void {
    if (this.searchDebounceTimer != null) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
    this.searchUserName = '';
    const event = this.lastLazyEvent || {
      first: 0,
      rows: this.limit,
      sortField: 'createdAt',
      sortOrder: -1,
      filters: {},
    };
    const filters = event.filters ? { ...event.filters } : {};
    delete filters.userName;
    this.loadUsersLazy({ ...event, first: 0, filters });
  }

  public deleteSelected(): void {
    this.dialogService
      .open(YesNoDialogComponent, {
        height: '300px',
        width: '300px',
        header: 'Eliminar usuario/s',
        data: {
          message: '¿Eliminar usuarios seleccionados?',
        },
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((result) => {
        if (result) {
          this.service
            .deleteUser(this.selectedRecords.map((r) => r.id))
            .pipe(takeWhile(() => !this.destroyed))
            .subscribe(() => {
              this.loadUsersLazy({ first: 0, rows: this.limit });
            });
        }
      });
  }

  public onRowEdit(user: IUser): void {
    this.router.navigate(['users', user.id]);
  }

  public newUser(): void {
    this.router.navigate(['users', 'new']);
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }

  reloadTable() {
    // const table = this.tableRef?.el.nativeElement;
    // table && table.dispatchEvent(new Event('lazyload')); // o dispara manualmente `loadUsersLazy`
  }
}
